let currentSlide = 0;

function checkSliderNeed() {
  const wrapper = document.querySelector('.sh-articles-slider-wrapper');
  const slider = document.getElementById('shArticlesCardsSlider');
  const nav = document.getElementById('articlesSliderNav');
  const button = document.getElementById('articlesSliderButton');
  const buttonMobile = document.getElementById('articlesSliderButtonMobile');
  const footer = document.getElementById('articlesSliderFooter');

  if (!wrapper || !slider || !nav || !button || !buttonMobile) return;

  const wrapperWidth = wrapper.offsetWidth;
  const sliderWidth = slider.scrollWidth;
  const needsSlider = sliderWidth > wrapperWidth;

  nav.style.display = needsSlider ? 'flex' : 'none';

  if (needsSlider) {
    button.style.display = 'none';
    buttonMobile.style.display = 'inline-flex';
    footer.style.display = 'block';
  } else {
    button.style.display = 'inline-flex';
    buttonMobile.style.display = 'none';
    footer.style.display = 'none';
  }

  if (button.style.display === 'none' && buttonMobile.style.display === 'none') {
    button.style.display = 'block';
  }
}

function slideCards(direction) {
  const slider = document.getElementById('shArticlesCardsSlider');
  const wrapper = document.querySelector('.sh-articles-slider-wrapper');
  const cards = slider.querySelectorAll('.sh-article-card-item');
  const totalCards = cards.length;

  if (totalCards === 0) return;

  const wrapperWidth = wrapper.offsetWidth;
  const gap = 2;
  
  // Calculate how many cards can fit in the visible area
  let totalVisibleWidth = 0;
  let cardsVisible = 0;
  
  for (let i = 0; i < totalCards; i++) {
    const cardWidth = cards[i].offsetWidth;
    const nextWidth = totalVisibleWidth + cardWidth + (i > 0 ? gap : 0);
    
    if (nextWidth <= wrapperWidth) {
      totalVisibleWidth = nextWidth;
      cardsVisible++;
    } else {
      break;
    }
  }
  
  const maxSlide = Math.max(0, totalCards - cardsVisible);
  currentSlide = Math.max(0, Math.min(maxSlide, currentSlide + direction));
  
  // Calculate exact translation by accumulating card widths
  let translateX = 0;
  for (let i = 0; i < currentSlide; i++) {
    translateX += cards[i].offsetWidth + gap;
  }
  
  slider.style.transform = `translateX(-${translateX}px)`;
}

function initSliderControls() {

  window.slideCards = slideCards;

  setTimeout(() => {
    checkSliderNeed();
    if (window.innerWidth <= 768) {
      slideCards(0);
    }
  }, 100);

  window.addEventListener('resize', function () {
    const slider = document.getElementById('shArticlesCardsSlider');
    if (slider) {
      slider.style.transform = 'translateX(0)';
    }
    currentSlide = 0;

    setTimeout(() => {
      checkSliderNeed();
    }, 100);
  });
}

export default {
  init() {
    initSliderControls();
  },

  finalize() {
  },
};